module.exports = __webpack_public_path__ + "img/手淘推荐示例图.6514ae24.jpeg";